import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';

export const LoadingSpinner = ({ className, size = 'default', text = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    default: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)} data-testid="loading-spinner">
      <Loader2 className={cn('animate-spin text-blue-600', sizeClasses[size])} />
      {text && <p className="text-sm text-slate-500">{text}</p>}
    </div>
  );
};

export const PageLoader = ({ text = 'Loading...' }) => (
  <div className="flex items-center justify-center min-h-[400px]" data-testid="page-loader">
    <LoadingSpinner size="lg" text={text} />
  </div>
);

export const SkeletonCard = () => (
  <div className="bg-white border border-slate-200 rounded-lg p-6 animate-pulse" data-testid="skeleton-card">
    <div className="h-4 bg-slate-200 rounded w-3/4 mb-4" />
    <div className="h-3 bg-slate-200 rounded w-full mb-2" />
    <div className="h-3 bg-slate-200 rounded w-5/6" />
  </div>
);

export const SkeletonTable = ({ rows = 5 }) => (
  <div className="space-y-3" data-testid="skeleton-table">
    {[...Array(rows)].map((_, i) => (
      <div key={i} className="flex gap-4 animate-pulse">
        <div className="h-4 bg-slate-200 rounded w-1/4" />
        <div className="h-4 bg-slate-200 rounded w-1/3" />
        <div className="h-4 bg-slate-200 rounded w-1/4" />
        <div className="h-4 bg-slate-200 rounded w-1/6" />
      </div>
    ))}
  </div>
);

export default LoadingSpinner;
